import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "vld-parent" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, " Parametrização do Layout do Sistema ", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Nome do Sistema", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Mensagem Boas vindas", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Mensagem Rodapé", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Image", -1)
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Categoria de Links Público", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, " Mostrar Links Publicos", -1)
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Rodapé - Coluna 1", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Rodapé - Coluna 2", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Rodapé - Coluna 3", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Rodapé - Coluna 4", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Facebook", -1)
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Instagram", -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary mb-4" }, "Salvar", -1)
const _hoisted_38 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_39 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_40 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ImageUpload = _resolveComponent("ImageUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "can-cancel": true,
        "on-cancel": $setup.onCancel
      }, null, 8, ["active", "on-cancel"])
    ]),
    _hoisted_3,
    _createElementVNode("form", {
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.nome_sistema) = $event)),
          class: "form-control",
          name: "nome_sistema"
        }, null, 512), [
          [_vModelText, $setup.data.nome_sistema]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.boasvinda) = $event)),
          class: "form-control",
          name: "boasvinda"
        }, null, 512), [
          [_vModelText, $setup.data.boasvinda]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.rodape) = $event)),
          class: "form-control",
          name: "rodape"
        }, null, 512), [
          [_vModelText, $setup.data.rodape]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.logo) = $event)),
            class: "form-control",
            name: "image"
          }, null, 512), [
            [_vModelText, $setup.data.logo]
          ]),
          _createVNode(_component_ImageUpload, {
            onUploaded: _cache[4] || (_cache[4] = ($event: any) => ($setup.data.logo = $event))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.carousel) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorias, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.id
            }, _toDisplayString(c1.short_name), 9, _hoisted_15))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.carousel]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.showcarousel) = $event)),
          class: "form-check-input",
          type: "checkbox",
          value: `${$setup.data.showcarousel}`,
          id: "flexCheckDefault",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkshowlink($setup.data.showcarousel)))
        }, null, 8, _hoisted_17), [
          [_vModelCheckbox, $setup.data.showcarousel]
        ]),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.col_um) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorias, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.id
            }, _toDisplayString(c1.short_name), 9, _hoisted_21))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.col_um]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.col_dois) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorias, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.id
            }, _toDisplayString(c1.short_name), 9, _hoisted_24))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.col_dois]
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.data.col_tres) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorias, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.id
            }, _toDisplayString(c1.short_name), 9, _hoisted_27))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.col_tres]
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.data.col_quatro) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorias, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.id
            }, _toDisplayString(c1.short_name), 9, _hoisted_30))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.col_quatro]
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.data.facebook) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.links, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.url_interno
            }, _toDisplayString(c1.short_name), 9, _hoisted_33))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.facebook]
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.data.instagram) = $event)),
          class: "form-select",
          "aria-label": "multiple select example"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.links, (c1) => {
            return (_openBlock(), _createElementBlock("option", {
              key: c1.id,
              value: c1.url_interno
            }, _toDisplayString(c1.short_name), 9, _hoisted_36))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.instagram]
        ])
      ]),
      _hoisted_37,
      ($setup.data.msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            ($setup.data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true),
            ($setup.data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}